import React, { useEffect } from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { InitAccountDrawer } from "./InitAccountDrawer";

export const Summary = () => {
    return (
        <>
            <PageHeader />
            <DataBox />
            <InitAccountDrawer />
        </>
    )
}